import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    FormControl,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio,
    Stack,
} from '@mui/material';
import { IUser } from '../definitions/app/user.d';

interface EditUserRoleModalProps {
    open: boolean;
    onClose: () => void;
    user: IUser | null;
    onUpdateRole: (user: IUser, newRole: string) => void;
}

const EditUserRoleModal: React.FC<EditUserRoleModalProps> = ({ open, onClose, user, onUpdateRole }) => {
    const [selectedRole, setSelectedRole] = useState('');

    useEffect(() => {
        if (user) {
            setSelectedRole(user.role || 'user'); // Assuming 'role' is the role property
        }
    }, [user]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedRole(event.target.value);
    };

    const handleSubmit = () => {
        if (user && selectedRole) {
            onUpdateRole(user, selectedRole);
        }
    };

    const roles = ['user', 'employee', 'admin', 'manager', 'superadmin'];

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
            <DialogTitle>Change User Role</DialogTitle>
            <DialogContent>
                <Stack spacing={2} sx={{ mt: 2 }}>
                    <FormControl component="fieldset">
                        <FormLabel component="legend">
                            Current Role: <span style={{ color: "red" }}>{user?.role || 'N/A'}</span>
                        </FormLabel>
                        <RadioGroup
                            aria-label="role"
                            name="role"
                            value={selectedRole}
                            onChange={handleChange}
                        >
                            {roles.map((option) => (
                                <FormControlLabel
                                    key={option}
                                    value={option}
                                    control={<Radio />}
                                    label={option.charAt(0).toUpperCase() + option.slice(1)}
                                />
                            ))}
                        </RadioGroup>
                    </FormControl>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="inherit">
                    Cancel
                </Button>
                <Button onClick={handleSubmit} variant="contained">
                    Update Role
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default EditUserRoleModal;